import {
  EventListFilter,
  eventListPath,
} from 'components/page/EventList/EventList.paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'

export const createEventListPath = () =>
  mergeAllUrls(eventListPath, EventListFilter.All)
